import React, { Suspense } from 'react'

const CheckoutTestPageBase = React.lazy(() => import('./CheckoutTest'))

export const CheckoutTestPage = () => (
  <Suspense fallback={null}>
    <CheckoutTestPageBase />
  </Suspense>
)
